/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faThumbtack } from '@fortawesome/pro-duotone-svg-icons';

import { TableRow, TableCell, Checkbox, Tooltip, IconButton, Menu, MenuItem,Typography } from '@material-ui/core'
import { MoreVert } from '@material-ui/icons'
import GroupIcon from './GroupIcon'

const blue_theme = createMuiTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      secondary: {
        main: "#dc014e",
      },
    },
});

const styles = theme => ({

})

class Group extends Component {
    state = {
        anchorEl : null
    }

    pinGroup = (event) => {
        event.stopPropagation();
        event.nativeEvent.stopImmediatePropagation();
        if (this.props.is_pinned) {
            this.props.pin_group(this.props.group_data.group_id, "unpin")
        } else {
            this.props.pin_group(this.props.group_data.group_id, "pin")
        }
    }

    highlightedName = () => {
        let start_index = this.props.group_data.matching_start_index
        let end_index = this.props.group_data.matching_end_index
        let text = this.props.group_data.group_name.split("").map((char, i) => {
            if (i >= start_index && i <= end_index) {
                return (
                    <mark style = {{backgroundColor : 'yellow', padding : 0}} key = {i}>{char}</mark>
                )
            } else {
                return (
                    <span>{char}</span>
                )
            }
        })

        return text
    }

    renderGroupCell = (cell) => {
        switch (cell) {
            case "$pin" :
                return (
                    <TableCell 
                        style = {{ 
                            border: 'none',
                            fontSize : 12
                        }}
                        onClick = {(event) => this.pinGroup(event)}
                    >
                        <Tooltip title = "Pin Group">
                            <div>
                                {this.props.is_pinned ? 
                                    <FontAwesomeIcon 
                                        style = {{
                                            transform : 'rotate(-90deg)',
                                            color : "#fc0303",
                                            cursor : 'pointer'
                                        }} 
                                        icon = {faThumbtack}
                                    /> 
                                    : 
                                    <FontAwesomeIcon 
                                        style = {{
                                            transform : 'rotate(-45deg)',
                                            opacity : '0.5',
                                            cursor : 'pointer'
                                        }} 
                                        icon = {faThumbtack}
                                    />
                                }
                            </div>
                        </Tooltip>
                    </TableCell>
                )
            
            case "Rank" :
                return (
                    <TableCell 
                        style = {{ 
                            border: 'none',
                            fontSize : 12,
                            color : '#707070',
                            fontWeight : 700
                        }}
                    >{'#' + this.props.group_data.rank}</TableCell>
                )
            
            case "$icon" :
                return (
                    <TableCell
                        style = {{ 
                            border: 'none',
                            padding: 0,
                            margin : 0
                        }}
                    >
                        <GroupIcon group_display_name = {this.props.group_display_name}/>
                    </TableCell>
                )
            
            case "Name" :
                return (
                    <TableCell 
                        style = {{ 
                            border: 'none',
                            fontSize : 12
                        }}
                    >
                        <div>
                            <Typography style = {{fontSize : 12}} variant = 'body2'>
                                {this.props.highlight_name ? this.highlightedName() : this.props.group_data.group_name}
                            </Typography>
                            {this.props.group_data.global_mapped_field !== null ? 
                                <Tooltip title = "Mapped to Global Field">
                                    <Typography 
                                        style = {{fontSize : 10, fontWeight : 600}} 
                                        variant = 'caption' 
                                        color = "primary" 
                                    >{this.props.group_data.global_mapped_field }</Typography>
                                </Tooltip> :
                                <Typography 
                                    style = {{fontSize : 10}} 
                                    variant = 'caption' 
                                    color = "textSecondary" 
                                ><em>Unmapped</em></Typography>
                            }
                        </div>
                </TableCell>
                )
            
            case "Fields" :
                return (
                    <TableCell 
                        style = {{ 
                            border: 'none',
                            fontSize : 12,
                            color : '#707070'
                        }}
                    >{this.props.group_data.fields.length}</TableCell>
                )
            
            case "Score" :
                return (
                    <TableCell 
                        style = {{ 
                            border: 'none',
                            fontSize : 13,
                            fontWeight : 900,
                            color : '#03AD93'
                        }}
                    >{this.props.group_data[this.props.score_field].toFixed(2)}</TableCell>
                )
            
            case "$options":
                return (
                    <TableCell 
                        style = {{ 
                            border: 'none',
                            padding: 0,
                            margin: 0
                        }}
                    > 
                        <IconButton style = {{padding : 0, margin : 0}} size = 'small' onClick = {(event) => {
                            event.stopPropagation();
                            event.nativeEvent.stopImmediatePropagation();
                            this.handleMenu(event)
                        }}>
                            <MoreVert style = {{color : '#707070'}} fontSize = 'small'/>
                        </IconButton>
                    </TableCell>
                )
            
            default: 
                return null
        }
    }

    renderGroupRow = () => {
        return (
            <TableRow style = {{
                backgroundColor : '#FFFFFF',
                padding : '10px',
                boxShadow : '1px 2px 12px -9px rgba(0,0,0,0.49)',
                width : '90%',
                cursor : 'pointer'
            }}
                onClick = {() => this.props.focus_group(this.props.group_data)}
            >
                {this.props.columns.map(cell => {
                    return this.renderGroupCell(cell)
                })}
            </TableRow>
        )
    }

    handleMenuClose = () => {
        this.setState({...this.state, anchorEl : null})
    }

    handleMenu = (event) => {
        if (this.state.anchorEl) {
            this.setState({...this.state, anchorEl : null})
        } else {
            this.setState({...this.state, anchorEl : event.currentTarget})
        }
    }

    renderMenu = () => {
        return (
            <Menu
                id="group_menu"
                anchorEl={this.state.anchorEl}
                keepMounted
                open={Boolean(this.state.anchorEl)}
                onClose={this.handleMenuClose}
            >
                <MenuItem
                    onClick = {() => {
                        this.setState({...this.state, anchorEl : null }, () => {
                            this.props.delete_group(this.props.group_data)
                        })
                    }}
                >{"Delete " + this.props.group_display_name}</MenuItem>
            </Menu>
        )
    }

    render() { 
        return (
            <ThemeProvider theme = {blue_theme}>
                {this.renderGroupRow()}
                {this.renderMenu()}
            </ThemeProvider>
        );
    }
}
 
export default withStyles(styles)(Group);